import type { Forum } from '@/types/site';

interface ForumCardProps {
  forum: Forum;
}

export default function ForumCard({ forum }: ForumCardProps) {
  return (
    <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300">
      <div className="flex items-center justify-between gap-3">
        <h3 className="font-heading text-base font-semibold text-foreground-950">{forum.name}</h3>
        <span className="whitespace-nowrap rounded-sm bg-secondary-100 px-2 py-1 text-[11px] text-secondary-800">
          {forum.mode}
        </span>
      </div>
      <p className="mt-1 text-xs text-foreground-500">{forum.categoryName}</p>

      <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-3">
        {forum.description}
      </p>

      <div className="mt-4 flex flex-wrap gap-1.5">
        {forum.tags.map((tag) => (
          <span key={tag} className="rounded-sm bg-background-100 px-2 py-1 text-[11px] text-foreground-600">
            {tag}
          </span>
        ))}
      </div>

      <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
        <span className="inline-flex items-center gap-1">
          <i className="ri-group-line text-secondary-600"></i>
          {forum.members} 成员
        </span>
        <span className="inline-flex items-center gap-1">
          <i className="ri-chat-3-line text-secondary-600"></i>
          {forum.threads} 主题
        </span>
        <a
          href={forum.url}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-1 whitespace-nowrap text-secondary-700 transition-colors hover:text-secondary-500 cursor-pointer"
        >
          进入社区<i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </article>
  );
}